module.exports = __webpack_public_path__ + "static/rohit-2475894a18b032014b489ffda7673ca7.png";